// import React from "react";
// import "./styles.css";

// function Footer() {
//   return <div className="footer">CryptoTracker. @ 2023</div>;
// }

// export default Footer;

import React from "react";
import "./styles.css";

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <p>Cryptocurrency Tracker © 2023</p>
        </div>
    </footer>
  );
}

export default Footer;
